import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export default function FaqSection({ faqs = [] }) {
  const [open, setOpen] = useState(null)

  if (!faqs.length) return null

  return (
    <section className="max-w-2xl mx-auto" aria-label="Frequently Asked Questions">
      <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-6 text-center">
        Frequently Asked Questions
      </h2>
      <div className="space-y-2">
        {faqs.map((faq, i) => (
          <div key={i} className="card overflow-hidden">
            <button
              className="w-full flex items-center justify-between px-5 py-4 text-left"
              onClick={() => setOpen(open === i ? null : i)}
              aria-expanded={open === i}
            >
              <span className="text-sm font-semibold text-slate-800 dark:text-slate-100 pr-4">{faq.q}</span>
              <ChevronDown
                size={16}
                className={`text-primary-500 shrink-0 transition-transform duration-200 ${open === i ? 'rotate-180' : ''}`}
              />
            </button>
            {open === i && (
              <div className="px-5 pb-4 animate-fade-in">
                <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">{faq.a}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* FAQ structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map(f => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          }),
        }}
      />
    </section>
  )
}
